import React, {Component} from 'react';
import {Trans} from 'react-i18next';
import pubsub from 'pubsub-js';
import {MultiContext} from '../../../Infrastructure/Authorization/Context/MultiContext';
import {CurrentPriceExtension, CurrentPriceProps, CurrentPriceResult} from '../../../../common/util/LicenseUtils/CurrentPriceExtension';

// Services
import LegacySensorService from '../SensorService';
import EditSensorService from '../SensorService';
import IssueProfileService from '../../../Services/IssueProfiles/IssueProfilesService';
import BillingService from '../../../Settings/Billing/BillingService';
import LicensingService from '../../../Settings/Licenses/LicensingService';

// Forms
import SensorBasicsFormComponent from '../Forms/SensorBasicsForm/SensorBasicsFormComponent';
import LimitAlarmsForm from '../Forms/LimitAlarmForm/LimitAlarmsForm';
import SensorIssuesFormComponent from '../Forms/SensorIssueForm/SensorIssuesFormComponent';
import SensorSummaryFormComponent from '../Forms/SensorSummary/SensorSummaryFormComponent';
import ConfigurationTemplatesForm from '../Forms/ConfigurationTemplatesForm';

// Utils
import RadialSteps from '../../../Common/RadialSteps';
import RegistryHelper, {showPriceWarning} from '../Utils/RegistryHelper';
import Message from '../../../Shared/Components/Message';
import {cleanUpSensorBasicFormData, DiscoverModuleChannelTypeToChannelType} from '../Utils/DiscoverModule';
import {RequestLogger} from '../../../Infrastructure/Requests/Logger';
import {
	getSensorBasicsFormSettingsForReConfiguration,
	getSensorPaymentMethodSettingsForReConfiguration,
	getSensorSummarySettingsForReConfiguration,
} from '../Helpers/WizardSettingsBuilder';
import {EditSensorState} from './EditSensorState';
import {RouteChildrenProps} from 'react-router-dom';
import {LimitAlarmFormState} from '../Forms/LimitAlarmForm/LimitAlarmFormState';
import {SensorBasicsForm, SensorBasicsFormChannel} from '../AddSensor/WizardState';
import {ExportFormStateAndSteps, WizardNavigationUtil} from '../../../Wizard/Util';
import {ContentWrapper, ViewWrapper} from '../../../Layout';
import {ViewHeader} from '../../../Common';
import {SmsAddonRequired} from '../Helpers/SmsAddonRequired';
import {AlarmLimitToLimitProfile} from '../Utils/AlarmLimitToLimitProfile';
import {Button, Col, Spin} from 'antd';
import {SensorService} from '../../../../common/services';
import {DiscoverModuleResponse} from '../../../../common/services/SensorService/DiscoverModuleResponse';
import {FeatureFlag} from '../../../../common/helpers';
import {GetChannelTypes} from '../Helpers/GetChannelTypes';
import {DeviceUtils} from '../../../../common/util';
import {
	GetInitialLicenseOfferingResult,
	SetUpCheckoutSession,
	SetUpSubscriptionUpdate,
	ShowSensorSettingsChangedMessage,
} from '../../../Wizard/Util/LicensingUtils';
import {getSensorStateAsync} from '../../../Wizard/Util/GetSensorStateAsync';
import {CalculateConfigurationChecksum} from '../../../../common/services/WebserverServicePro/DeviceService';
import {prepareConnectModuleRequest} from '../Helpers/SensorConnectRequestBuilder';
import {ReportService} from '../../../../common/services/ReportService';
import {IssueAlarmFormState} from '../Forms/SensorIssueForm/IssueAlarmFormState';
import {IssueAlarmToIssueProfile} from '../Utils/IssueAlarmToIssueProfile';
import findFamilyTypeFromTemplateName from '../../../../components/Shared/Extensions/DeviceModuleFamilyTypeFinder';
import { GetSensorSteps } from '../AddSensor/GetSensorSteps';
import MetadatasForm from '../Forms/MetadatasForm';
import { Template } from 'common/types/DbModel';

class EditSensor extends Component<RouteChildrenProps, EditSensorState> {
	static contextType = MultiContext;

	declare context: React.ContextType<typeof MultiContext>;

	constructor(props) {
		super(props);

		let current_step = 0;

		this.state = {
			formStates: null,
			loading: true,
			updating: false,
			id: props.match.params.id,
			templateName: '',
			current_step: current_step,
			steps: GetSensorSteps(false, null, true),
			uncounted_steps: 1,
			moduleForm: {
				serial_number: props.location.state.serial_number,
			},
			licenseOffering: {
				baseLicenses: [],
				loggingIntervals: [],
				limitEmail1: undefined,
				limitEmail2: undefined,
				limitSms1: undefined,
				limitSms2: undefined,
				issueEmail: undefined,
				issueSms: undefined,
				retirement1: undefined,
				retirement2: undefined,
			},
			licenseOfferingResult: undefined,
			offering: null,
			hasSubscription: false,
			currentLimitAlarmsFormIndex: 0,
			sensorBasicsForm: {
				last_run_only: false,
				isConfiguration: true,
				sensor_name: '',
				customer_id: '',
				logging_interval: 600,
				unit: null,
				memo: '',
				firmware: '',
				active: false,
				moduleData: null,
				currentModuleChannels: null,
				selectedChannel: null,
				communication_interval: null,
				communication_mode: null,
				defaultSettingUnit: null,
				disableChangeLogging: null,
			},
			summaryForm: {
				start_sensor: false,
				vouchers: [],
				offering: undefined,
				errorMessage: '',
				terms_of_use: false,
				disable_sensor_update_msg: '',
			},
			metadatasForm: {
				sensor_name: '',
				customer_id: '',
				memo: '',
				metadata_1: '',
				metadata_2: '',
				metadata_3: '',
				metadata_4: '',
				metadata_5: '',
				metadata_6: '',
				metadata_7: '',
				metadata_8: '',
			},

			// Additional Configuration
			additionalConfiguration: {
				has_additional_configuration: false,
				configuration_templates: null,
				configuration_template: null,
				configuration_template_result: null,
				communication_mode_templates: null,
				additional_configuration_forms: null,
			},
		};
	}

	componentDidMount() {
		this.getModuleInformation();
	}

	getModuleInformation() {
		let gets = [
			EditSensorService.sensor(this.state.id),
			IssueProfileService.issueProfiles({}, RequestLogger.createLogData('edit-sensor', 'load-issue-profiles', 'onLoad')),
			LicensingService.getSensorLicense(this.state.id, RequestLogger.createLogData('edit-sensor', 'load-licence', 'onLoad')),
			SensorService.DiscoverModule(this.props.location.state['serial_number']),
			getSensorStateAsync(this.state.id),
		];

		Promise.all(gets).then(responses => {
			const sensorData = responses[0].data;
			const issueProfiles = responses[1].data;
			const sensorLicense = responses[2].data[0];
			const moduleData = responses[3] as DiscoverModuleResponse;
			const sensorState = responses[4];

			this.setState(prevState => ({
				summaryForm: {
					...prevState.summaryForm,
					sensorLicense: sensorLicense,
				},
			}));

			const currentChannel = moduleData.module?.used_channels?.find(
				channel => channel.sensors_id.toString() === this.state.id.toString()
			);
			const channelDescription = moduleData.module.channels.find(c => c.channel_number == currentChannel.channel_number);
			const channelType = moduleData.channel_types.find(
				c => c.channel_type == channelDescription.channel_type && c.value_index == currentChannel.value_index
			);

			const selectedChannel: SensorBasicsFormChannel = {
				channel_types: [DiscoverModuleChannelTypeToChannelType(channelType, moduleData)],
				selectedChannel: currentChannel.channel_number,
				selectedValueIndex: currentChannel.value_index,
				...currentChannel,
			};

			const currentModuleChannels = {channelsUsed: [selectedChannel], channelsFree: []};

			const sensorBasicsForm: SensorBasicsForm = {
				...this.state.sensorBasicsForm,
				last_run_only: sensorData.last_run_only,
				isConfiguration: true,
				sensor_name: sensorData.name,
				customer_id: sensorData.customer_id,
				logging_interval: sensorData.logging_interval,
				unit: sensorData.out_units_id,
				memo: sensorData.memo || '',
				firmware: sensorData.firmware || '',
				moduleData: {
					channel_types: moduleData.channel_types.map(c => DiscoverModuleChannelTypeToChannelType(c, moduleData)),
					module: {
						module_id: moduleData.module.module_id,
						channels: moduleData.module.channels,
						used_channels: moduleData.module.used_channels,
					},
				},
				currentModuleChannels: currentModuleChannels,
				selectedChannel: selectedChannel,
			};

			GetInitialLicenseOfferingResult(
				moduleData.module.module_id?.toString(),
				sensorData.serial_number,
				this.state.currentLimitAlarmsFormIndex,
				sensorBasicsForm,
				sensorState?.formStates?.limitAlarmForms[0],
				sensorState?.formStates?.issueAlarmForm
			).then(result => this.setState(prevState => ({...prevState, ...result}), this.getLicenseOfferings));

			this.setState(prevState => ({
				...prevState,
				sensorLicense: sensorLicense,
				sensor_state: sensorData.state,
				formStates: sensorState?.formStates,
				moduleForm: {
					serial_number: sensorData.serial_number,
				},
				sensorBasicsForm: sensorBasicsForm,
				issueProfiles: issueProfiles,
				loading: false,

				metadatasForm: {
					sensor_name: sensorData.name || '',
					customer_id: sensorData.customer_id || '',
					memo: sensorData.memo || '',
					metadata_1: sensorData.metadata?.metadatas?.metadata_1 || '',
					metadata_2: sensorData.metadata?.metadatas?.metadata_2 || '',
					metadata_3: sensorData.metadata?.metadatas?.metadata_3 || '',
					metadata_4: sensorData.metadata?.metadatas?.metadata_4 || '',
					metadata_5: sensorData.metadata?.metadatas?.metadata_5 || '',
					metadata_6: sensorData.metadata?.metadatas?.metadata_6 || '',
					metadata_7: sensorData.metadata?.metadatas?.metadata_7 || '',
					metadata_8: sensorData.metadata?.metadatas?.metadata_8 || '',
				},
				additionalConfiguration: {
					...prevState.additionalConfiguration,
					has_additional_configuration: true,
					configuration_templates: moduleData.module.configuration_templates,
					configuration_template: new Map<string, Template>(),
					configuration_template_result: sensorData.metadata,
					communication_mode_templates: moduleData.module.communication_mode_templates,
					additional_configuration_forms: {},
				},
			}));

			this.setState(prevState => ({...prevState, cache: prevState}));

			this.setState(prevState => prevState, this.getOffering);

			const hasConfigurationTemplates =
				!!moduleData.module.configuration_templates && moduleData.module.configuration_templates.length > 0;

			const configTemplateName = findFamilyTypeFromTemplateName(moduleData.module.configuration_templates?.[0]?.name ?? null);

			this.setState(prevState => ({
				...prevState,
				templateName: configTemplateName,
				steps: GetSensorSteps(hasConfigurationTemplates, false, false, configTemplateName),
				uncounted_steps: 2,
			}));
		});
	}

	handleSensorBasicsInputChange = event => {
		const input = event.target;
		const value = input.type === 'checkbox' ? input.checked : input.value;

		this.setState(prevState => ({
			...prevState,
			sensorBasicsForm: {
				...prevState.sensorBasicsForm,
				[input.name]: value,
			},
		}));
	};

	handleMetadatasInputChange = event => {
		const input = event.target;
		const value = input.type === 'checkbox' ? input.checked : input.value;

		this.setState(prevState => ({
			...prevState,
			metadatasForm: {
				...prevState.metadatasForm,
				[input.name]: value,
			},
		}));
	};

	handleConfigurationTemplateForm = (id, skipped = false) => {
		LegacySensorService.configuration_template(
			id,
			RequestLogger.createLogData('edit-libero-gx', 'load-configuration-template', 'onLoad')
		).then(response => {
			const configTemplateName = findFamilyTypeFromTemplateName(response.data.name);
			this.setState(prevState => ({
				additionalConfiguration: {
					...prevState.additionalConfiguration,
					configuration_template: response.data.template,
					configuration_template_result: {
						...prevState.additionalConfiguration.configuration_template_result,
						configuration_templates_id: id,
					},
				},
				templateName: configTemplateName,
				steps: GetSensorSteps(true, response.data.template, false, configTemplateName),
			}));

			if (skipped === false) this.next();
		});
	};

	setOfferingObject = offeringObject => {
		this.setState({offering: offeringObject});
		if (offeringObject.voucher_rest > 0) {
			this.setState({
				summaryForm: {
					...this.state.summaryForm,
					disable_sensor_update_msg:
						'Update is not possible because voucher not fully redeemable (' +
						offeringObject.voucher_rest +
						' CHF remaining)' +
						'. Please use prepaid credit.',
				},
			});
		}
	};

	back = () => {
		this.updateCurrentStep(this.state.current_step - 1);

		// set terms of use and disable update warning message to false, when go back 1 step
		this.setState({
			summaryForm: {
				...this.state.summaryForm,
				disable_sensor_update_msg: '',
			},
		});
	};

	next = () => {
		let nextStep = this.state.current_step;

		if (nextStep === 0 && Array.isArray(this.state?.additionalConfiguration?.configuration_templates)) {
			const firstTemplateId = this.state.additionalConfiguration.configuration_templates[0].id;
			this.handleConfigurationTemplateForm(firstTemplateId, true);
		}

		this.updateCurrentStep(WizardNavigationUtil.GetNextStep(this.state, 'forward'));
		return null;
	};

	updateSensor = creditCard => {
		const basicForm = {
			...this.state.sensorBasicsForm,
			channel_number: this.state.sensorBasicsForm.selectedChannel ? this.state.sensorBasicsForm.selectedChannel.channel_number : null,
			value_index: this.state.sensorBasicsForm.selectedChannel ? this.state.sensorBasicsForm.selectedChannel.value_index : null,
		};

		this.setState(
			{
				sensorBasicsForm: cleanUpSensorBasicFormData(basicForm),
				updating: true,
			},
			() => {
				const payload = {
					sensor_id: this.state.id,
					PaymentInformation: {
						vouchers: this.state.summaryForm.vouchers,
						credit_card: creditCard,
						redeem_prepaid: creditCard.redeem_prepaid,
					},
					logging_interval: this.state.sensorBasicsForm.logging_interval,
					sms_notifications: SmsAddonRequired(
						this.state.moduleForm.serial_number,
						this.state.sensorBasicsForm?.selectedChannel?.selectedChannel,
						this.state.sensorBasicsForm?.selectedChannel?.selectedValueIndex,
						this.state.formStates?.limitAlarmForms,
						this.state.formStates?.issueAlarmForm
					),
					offer_total: this.state.offering === undefined ? 0 : this.state.offering.actual_price,
				};

				// martin: do the feature change by stripe before the module change(s)
				// if update module has returned error and license feature could still be changed before
				// changes to the license-model are apply next time, there wont be an additional booking
				// when no changes made to sms/logging_interval there will not be booking
				LicensingService.changeLicenseFeatures(
					payload,
					RequestLogger.createLogData('edit-sensor', 'change-license-feature', 'onClick')
				)
					.then(() => {
						this.updateModule();
					})
					.catch(error => Message.error('Error', 'Changes could not be saved', error))
					.finally(() => this.setState({updating: false}));
			}
		);
	};

	updateModule() {
		const payload = {
			Sensor: {...this.state.sensorBasicsForm, id: this.state.id},
			Metadata : this.state.metadatasForm,
			SensorLimitAlarm: AlarmLimitToLimitProfile(this.state.formStates.limitAlarmForms[0]),
			SensorIssueAlarm: IssueAlarmToIssueProfile(this.state.formStates.issueAlarmForm),
		};

		LegacySensorService.updateModule(payload, RequestLogger.createLogData('edit-sensor', 'edit-sensor', 'onClick'))
			.then(() => {
				const successForwardUrl = '/dashboard';
				this.props.history.push(successForwardUrl);
				ShowSensorSettingsChangedMessage();
			})
			.catch(error => {
				RegistryHelper.logPublishAndToast(error, pubsub.publish.bind(null, 'catchRegistryExceptions'), 'updating');
			})
			.finally(() => this.setState({updating: false}));
	}

	limitAlarmsFormBack = () => {
		if (this.state.currentLimitAlarmsFormIndex === 0) {
			this.back();
		} else {
			this.setState(prevState => ({currentLimitAlarmsFormIndex: prevState.currentLimitAlarmsFormIndex - 1}));
		}
	};

	limitAlarmsFormNext = () => {
		if (
			this.state.currentLimitAlarmsFormIndex ===
			GetChannelTypes(this.state.sensorBasicsForm, DeviceUtils.GetDeviceFamily(this.state.moduleForm.serial_number)).length - 1
		) {
			this.next();
		} else {
			this.setState(prevState => ({currentLimitAlarmsFormIndex: prevState.currentLimitAlarmsFormIndex + 1}));
		}
	};

	getLicenseOfferings = (redeem_prepaid?: boolean) => {
		this.getOffering(redeem_prepaid);
	};

	getOffering = (redeem_prepaid?: boolean, limitAlarmFormState?: LimitAlarmFormState[], issueAlarmFormState?: IssueAlarmFormState) => {
		this.setState({offering: undefined});

		const payload = {
			sensor_id: this.state.id,
			vouchers: this.state.summaryForm.vouchers,
			redeem_prepaid: redeem_prepaid || false,
			want_logging_interval: this.state.sensorBasicsForm.logging_interval,
			want_sms_notification: SmsAddonRequired(
				this.state.moduleForm.serial_number,
				this.state.sensorBasicsForm.selectedChannel?.selectedChannel,
				this.state.sensorBasicsForm.selectedChannel?.selectedValueIndex,
				limitAlarmFormState || this.state.formStates?.limitAlarmForms,
				issueAlarmFormState || this.state.formStates?.issueAlarmForm
			),
		};

		BillingService.getOfferingUpgrade(payload, RequestLogger.createLogData('edit-sensor', 'load-offering-upgrade', 'onClick'))
			.then(response => {
				this.setOfferingObject(response.data);
			})
			.catch();
		
		// cache default offering
		this.setState({cache: {...this.state.cache, offering: this.state.offering}});
	};

	updateCurrentStep = step => {
		this.setState({current_step: step});
		pubsub.publish('addNewSensorStepChanged', {current_step: step});
		this.getOffering();
	};

	close = e => {
		const DevicesViewSettings = this.context.AccessContext.user.user_settings.devicesViewSettings;
		this.props.history.push(DevicesViewSettings.view);
		e.preventDefault();
	};

	handleTermsOfUse = _ => {
		this.setState({
			summaryForm: {
				...this.state.summaryForm,
				terms_of_use: !this.state.summaryForm.terms_of_use,
			},
		});
	};

	handleConfigFormSubmit = (e, section) => {
		e.preventDefault();

		if (this.state.additionalConfiguration.additional_configuration_forms[`${section}IsValid`]) {
			this.next();
		}
	};

	getCurrentPriceObject = (): CurrentPriceResult => {
		let currentPriceProps: CurrentPriceProps = {
			totalAmount: this.state.licenseOfferingResult?.totalAmount,
			actualPrice: this.state.offering?.actual_price,
			currency: this.state.licenseOfferingResult?.currency,
			interval: this.state.licenseOfferingResult?.lineItems[0]?.interval,
			isSmsDowngradeFromLicenseModel: this.state.offering?.is_sms_downgrade_from_license_model,
		};
		return CurrentPriceExtension.getCurrentPrice(currentPriceProps, this.context.FeatureFlagsContext);
	};

	saveLimitAlarmStateCallback = (limitAlarmFormState: LimitAlarmFormState) => {
		const updateState = ExportFormStateAndSteps(this.state, 0, limitAlarmFormState);

		let formStates = this.state.formStates;
		formStates.limitAlarmForms[0] = limitAlarmFormState;

		this.setState(prev => ({...prev, ...updateState, formStates: formStates}));
	};

	onLimitAlarmFormStateChange = (index: number, limitAlarmFormState: LimitAlarmFormState) => {
		const limitAlarmsDraft = structuredClone(this.state.formStates?.limitAlarmForms);
		if (limitAlarmFormState.alarmLimit && limitAlarmFormState.recipients) limitAlarmsDraft[index] = limitAlarmFormState;
		this.getOffering(null, limitAlarmsDraft);
	};

	saveIssueAlarmStateCallback = (issueAlarmFormState: IssueAlarmFormState) => {
		let formStates = this.state.formStates;
		formStates.issueAlarmForm = issueAlarmFormState;

		this.setState(prev => ({...prev, formStates: formStates}));
	};

	onIssueAlarmFormStateChange = (issueAlarmFormState: IssueAlarmFormState) => {
		this.getOffering(null, null, issueAlarmFormState);
	};

	calculateCheckSum = async (): Promise<string> => {
		const data = await prepareConnectModuleRequest(
			this.state.sensorBasicsForm,
			this.state.moduleForm,
			this.state.formStates,
			this.state.summaryForm,
			this.state.offering
		);
		return data?.additional_configuration?.config_id ?? (await CalculateConfigurationChecksum(data));
	};

	exportSensorConfigAsReport = async () => {
		const data = await prepareConnectModuleRequest(
			this.state.sensorBasicsForm,
			this.state.moduleForm,
			this.state.formStates,
			this.state.summaryForm,
			this.state.offering
		);
		await ReportService.DownloadDeviceConfigurationReport(data);
	};

	render() {
		return (
			<ViewWrapper>
				<ViewHeader heading={'Edit sensor'}>
					<Col>
						<Button type="primary" className="btn" onClick={this.close} size="large">
							<em className="fsInButton elpro-Close fa-fw" />
							<Trans i18nKey={'buttons.close'} />
						</Button>
					</Col>
				</ViewHeader>
				<ContentWrapper>
					<Spin spinning={this.state.updating}>
						<div style={{paddingRight: '85px'}}>
							{
								<Col>
									{this.state.current_step >= 0 && (
										<RadialSteps
											current_step={this.state.current_step}
											steps={this.state.steps}
											uncounted_steps={this.state.uncounted_steps || 0}
										/>
									)}
								</Col>
							}

							{this.state.additionalConfiguration.has_additional_configuration &&
								(this.state.current_step === 0 || this.state.current_step === 1) &&
								(this.state.additionalConfiguration.configuration_templates.length > 1 ? (
									<ConfigurationTemplatesForm
										configurationTemplate={
											this.state.additionalConfiguration.configuration_template_result?.['configuration_templates_id'] || ''
										}
										configurationTemplates={this.state.additionalConfiguration.configuration_templates}
										handleConfigurationTemplateForm={this.handleConfigurationTemplateForm}
										onNext={this.next}
									/>
								) : (
									this.next()
								))}

							{this.state.current_step === 0 || (this.state.additionalConfiguration.has_additional_configuration && this.state.current_step === 2) && (
								<SensorBasicsFormComponent
									hasConfigurationTemplate={this.state.additionalConfiguration.has_additional_configuration}
									lastRunOnly={this.state.sensorBasicsForm.last_run_only}
									sensorBasicsForm={this.state.sensorBasicsForm}
									handleSensorBasicsInputChange={this.handleSensorBasicsInputChange}
									currentPrice={this.getCurrentPriceObject()}
									onNext={this.next}
									onBack={
										this.state.additionalConfiguration.configuration_template ? this.back : null
									}
									sensorBasicsFormSettings={getSensorBasicsFormSettingsForReConfiguration(
										this.state.moduleForm.serial_number
									)}
									templateName={this.state.templateName}
									serialNumber={this.state.moduleForm.serial_number}
									isReRun={true}
								/>
							)}

							{this.state.additionalConfiguration.has_additional_configuration && this.state.current_step === 3 && (
								<MetadatasForm
									metadatasForm={this.state.metadatasForm}
									handleMetadatasInputChange={this.handleMetadatasInputChange}
									onBack={this.back}
									onNext={this.next}
									configurationTemplateName={this.state.templateName}
									hasConfigurationTemplate={this.state.additionalConfiguration.has_additional_configuration}
								/>
							)}

							{((!this.state.additionalConfiguration.has_additional_configuration && this.state.current_step === 2) ||
								(this.state.additionalConfiguration.has_additional_configuration && this.state.current_step === 4)) &&
								GetChannelTypes(
									this.state.sensorBasicsForm,
									DeviceUtils.GetDeviceFamily(this.state.moduleForm.serial_number)
								).map(
									(channelType, idx: number) =>
										idx == this.state.currentLimitAlarmsFormIndex && (
											<LimitAlarmsForm
												channelType={this.state.sensorBasicsForm.selectedChannel.channel_types.at(0)}
												currentPrice={this.getCurrentPriceObject()}
												onBack={this.limitAlarmsFormBack}
												onNext={this.limitAlarmsFormNext}
												interval={this.state.sensorBasicsForm.logging_interval}
												unit={this.state.sensorBasicsForm.unit}
												sensorIndex={null}
												saveStateCallback={limitAlarmFormState =>
													this.saveLimitAlarmStateCallback(limitAlarmFormState)
												}
												initialState={this.state.formStates?.limitAlarmForms[0]}
												moduleSerialNumber={this.state.moduleForm.serial_number}
												onFormStateChange={limitAlarmFormState =>
													this.onLimitAlarmFormStateChange(idx, limitAlarmFormState)
												}
											/>
										)
								)}
								{((!this.state.additionalConfiguration.has_additional_configuration && this.state.current_step === 3) ||
									(this.state.additionalConfiguration.has_additional_configuration &&
										this.state.current_step === 5)) && (
								<SensorIssuesFormComponent
									initialState={this.state.formStates?.issueAlarmForm}
									moduleSerialNumber={this.state.moduleForm.serial_number}
									currentPrice={this.getCurrentPriceObject()}
									onBack={this.back}
									onNext={this.next}
									onFormStateChange={issueAlarmFormState => this.onIssueAlarmFormStateChange(issueAlarmFormState)}
									saveStateCallback={issueAlarmFormState => this.saveIssueAlarmStateCallback(issueAlarmFormState)}
								/>
							)}
							{this.state.current_step === this.state.steps.length - 1 && (
								<SensorSummaryFormComponent
									additional_configuration={this.state.additionalConfiguration.configuration_template_result}
									configuration_template={this.state.additionalConfiguration.configuration_template}
									formStates={{
										...this.state.formStates,
										limitAlarmForms: [this.state.formStates?.limitAlarmForms[0]],
									}}
									getLicenseOfferings={this.getLicenseOfferings}
									getOffering={this.getOffering}
									handleTermsOfUse={this.handleTermsOfUse}
									licenseOfferingResult={this.state.licenseOfferingResult}
									metadatasForm={this.state.metadatasForm}
									moduleForm={this.state.moduleForm}
									offering={this.state.offering}
									onBack={this.back}
									onUpdateSensor={this.updateSensor}
									sensorBasicsForm={this.state.sensorBasicsForm}
									sensorPaymentMethodSettings={getSensorPaymentMethodSettingsForReConfiguration(
										this.state.moduleForm.serial_number
									)}
									sensorSummarySettings={getSensorSummarySettingsForReConfiguration(
										this.state.moduleForm.serial_number
									)}
									setOfferingObject={this.setOfferingObject}
									summaryForm={this.state.summaryForm}
									calculateChecksum={this.calculateCheckSum}
									exportSensorConfigAsReport={this.exportSensorConfigAsReport}
								/>
							)}
						</div>
					</Spin>
				</ContentWrapper>
			</ViewWrapper>
		);
	}
}

export default EditSensor;
